import {FETCH_GALLERY_IMAGES, GALLERY_IMAGE_TO_UPLOAD, THUMBNAIL_GALLERY_IMAGE_TO_UPLOAD, OPEN_GALLERY_MODAL} from 'GalleryActions';

export function fetchGallery(state = [], action) {
    switch (action.type) {
        case FETCH_GALLERY_IMAGES:
            return action.payload;
        default:
            return state;
    }
}

export function galleryModal(state = {}, action) {
    switch (action.type) {
        case OPEN_GALLERY_MODAL:
            return action.payload;
        default:
            return state;
    }
}

export function thumbnailImage(state = {}, action) {
    switch (action.type) {
        case THUMBNAIL_GALLERY_IMAGE_TO_UPLOAD:
            return action.payload;
        default:
            return state;
    }
}

export function imageReadyToAddGallery(state = {}, action) {
    switch (action.type) {
        case GALLERY_IMAGE_TO_UPLOAD:
            return action.payload;
        default:
            return state;
    }
}